import { createFileRoute } from '@tanstack/react-router'
import ActivateUser from '../../../../../containers/activate-user'
import { activateSearchSchema } from './search-schemas'

export const Route = createFileRoute(
  '/_unauthenticated/activate/$type/$token/'
)({
  component: ActivateUser,
  validateSearch: activateSearchSchema
})
